import React, {useEffect, useState} from "react";
import Button from "../component/button"
import TextInput from "../component/textInput"
import Item from "../component/item";

import logoutIcon from "../image/logout_icon.svg"

const loginDiv = {
  margin: "10px auto auto auto",
  width: "30%",
  minWidth: "300px",
  border: "3px solid black",
  padding: "10px",
  borderRadius: "10px",
  textAlign: 'center'
}

const notOpenDiv = {
  margin: "10px auto auto auto",
  width: "30%",
  minWidth: "300px",
  padding: "10px",
  textAlign: 'center'
}

const logoutButton = {
  cursor: "pointer",
  height: "50px",
  display: "flex",
  justifyContent: "flex-end",
  margin: "20px 20px 0px 0px"
}

const errorMessage = {
  width: "80%",
  margin: "10px auto 0px auto",
  backgroundColor: " #ff000080",
  borderRadius: "4px"
}

export default function Home({connexion, data, offerButton, logoutUser, userNotFound}) {
  const [pseudo, setPseudo] = useState("");
  const [password, setPassword] = useState("");

  const optionsDate = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  const optionsTime = {
    hour: "numeric",
    minute: "numeric"
  };

  function onPseudoChange(pseudo){
    setPseudo(pseudo)
  }

  function onPasswordChange(password) {
    setPassword(password)
  }

  function checkAccount() {
    connexion(pseudo, password)
  }

  function logout() {
    setPseudo("")
    setPassword("")
    logoutUser()
  }

  function getStartDate() {
    let date = new Date(data.startDate)
    let string = date.toLocaleDateString("fr-BE", optionsDate) + " à " + date.toLocaleTimeString("fr-BE", optionsTime)
    return string
  }

  function getEndDate() {
    let date = new Date(data.endDate)
    let string = date.toLocaleDateString("fr-BE", optionsDate) + " à " + date.toLocaleTimeString("fr-BE", optionsTime)
    return string
  }

  return (
    <div>
      {data.connected!=="" ?
        <div>
          <div style={logoutButton} onClick={logout}>
            <img src={logoutIcon} title="Se déconnecter" alt="Se déconnecter"/>
          </div>
          {
            data.items.length > 0 && data.items.map((element, i) => {
              if(element.available != false) {
                return <Item data={element} userData={data.userId} offerButton={offerButton.bind()} hide={data.connected === "admin"}/>
              }
            })
          }
        </div>
      :
      data.isOpen ?
      <div>
        <div style={loginDiv}>
          <TextInput placeholderText="pseudo" value={pseudo} onChange={onPseudoChange} enterCallback={checkAccount}/>
          <TextInput placeholderText="mot de passe" value={password} onChange={onPasswordChange} isPassword={true} enterCallback={checkAccount}/>
          {userNotFound ? 
          <div style={errorMessage}>Nom de compte ou mot de passe erroné</div>
           : <div></div>}
          <Button name="connexion" onClick={checkAccount}/>
          <p>Pas de compte ? Mot de passe oublié ? <br/>
          Envoyez un mail à <a href="mailto:contact@anthonyierace.be?subject=Demande wishlist&body=Pseudo%20%3A%20%0A%0ADemande%20%3A%20">contact@anthonyierace.be</a><br/>
          Avec votre pseudo (actuel ou souhaité)
          </p>
        </div>
      </div>
      :
      <div style={notOpenDiv}>
        <h1>La liste n'est pas encore ouverte !</h1>
        <p>La liste n'est pas encore ouverte, elle sera ouverte du <b><u>{getStartDate()}</u></b> au <b><u>{getEndDate()}</u></b></p>
        <p>En attendant, vous pouvez soit trouver quelque chose par vous-même ou bien revenir plus tard lorsque la liste sera ouverte.</p>
      </div>
      }
      
    </div>
  );
}
